import {useEffect, useState} from "react";

const SurveyOverviewResendSelector = (props) => {

    const people = props.people;
    const result = props.result

    const buttons = [{"text":"Confirm", "id": "1"}, {"text":"Cancel", "id": "2"}];


    const footerClick = (ev) => {
        if (!ev) return;
        let res = {"button": ev.target.id}
        result(res)
    }

    return (
        <>
            <div className="page-mask"/>
            <div className="participant-selector-container">
                <div className="participant-selector-header-container">
                    <div className="participant-selector-header">
                        {props.title ? props.title : "Summary Participant Selection"}
                    </div>
                </div>
                <div className="participant-selector-body-description-container">
                    Are you sure you want to send invitations to the following participants?
                </div>
                <div className="participant-selector-body-container">
                    <div className="participant-selector-grid">
                        {people && people.map((person, idx) => {
                            return (
                                <div className={`participant-selector-row`} key={idx}>
                                    <div className="participant-selector-name">{person.name}</div>
                                    <div className="participant-selector-percentage">{person.percentage_complete ? person.percentage_complete : 0}%</div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className="participant-selector-footer-container">
                    {buttons && buttons.map((button, idx) => {
                        return (
                            <div className="participant-selector-footer-button link" id={button.id}
                                 onClick={footerClick} key={idx}>
                                {button.text}
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    )

}

export default SurveyOverviewResendSelector